/** Standard Duration's presentation precision is six fractional seconds. */
export function formatDurationSeconds(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return "";
  const rounded = Number(seconds.toFixed(6));
  const minutes = Math.floor(rounded / 60);
  const remainder = Number((rounded - minutes * 60).toFixed(6));
  return `${minutes}:${remainder < 10 ? "0" : ""}${remainder}`;
}

/** Seconds, or minutes:seconds with exactly two digits in the seconds part. */
export function parseDurationSeconds(text: string): number | undefined {
  const trimmed = text.trim();
  if (/^\d+(?:\.\d+)?$/.test(trimmed)) {
    const value = Number(trimmed);
    return Number.isFinite(value) ? value : undefined;
  }
  const match = /^(\d+):([0-5]\d(?:\.\d+)?)$/.exec(trimmed);
  if (!match) return undefined;
  const value = Number(match[1]) * 60 + Number(match[2]);
  return Number.isFinite(value) ? value : undefined;
}
